import styled from 'styled-components';

export const Container = styled.div`
  &.bg-banner-in-sample {
    background: #01888b;

    @media only screen and (max-width: 768px) {
      height: 240px;
    }
  }

  h3 {
    color: ${(props) => props.theme.$white};
    margin: 0 0 0.3rem 0;
  }

  p {
    color: ${(props) => props.theme.$white};
    margin: 0;
  }

  .btn-in-sample {
    background: #cfeaea;
    border-color: #cfeaea;
    color: #184f71;
  }
`;
